"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const luxon_1 = require("luxon");
const index_1 = require("../index");
const AttributeSelector_1 = require("./AttributeSelector");
const BooleanOperatorValueSelector_1 = require("./BooleanOperatorValueSelector");
const DateOverviewSelector_1 = require("./DateOverviewSelector");
const DatePickerSelector_1 = require("./DatePickerSelector");
const OperatorSelector_1 = require("./OperatorSelector");
const PredicateInputValue_1 = require("./PredicateInputValue");
const PredicateListValue_1 = require("./PredicateListValue");
const PredicateRangeValue_1 = require("./PredicateRangeValue");
const PredicateDateTimePageSelector_1 = require("./PredicateDateTimePageSelector");
const PredicateListDatePageValueIndexSelector_1 = require("./PredicateListDatePageValueIndexSelector");
const PredicateRangeDatePageValueIndexSelector_1 = require("./PredicateRangeDatePageValueIndexSelector");
const TimePickerSelector_1 = require("./TimePickerSelector");
const TimeZoneSelector_1 = require("./TimeZoneSelector");
const utils_1 = require("./utils");
const GeofenceInput_1 = require("../GeofenceInput");
const PredicateListInput_1 = require("./PredicateListInput");
class PredicateBuilder extends React.Component {
    constructor(props) {
        super(props);
        if (props.selectedPredicate != null) {
            const { selectedPredicate, schemas, listEnabledKeyPaths } = props;
            const { keyPath, modifier, operator, value } = selectedPredicate;
            this.state = {
                page: 'newCondition',
                keyPathSelected: keyPath,
                operatorSelected: utils_1.getOperators(keyPath, schemas, listEnabledKeyPaths, modifier).find(operatorComponent => operatorComponent.comparisonOperator === operator),
                selectorAnimationDirection: null,
                value: Object.values(value).find(v => v != null),
                selectedValueIndex: undefined,
            };
        }
        else {
            this.state = {
                page: 'selectAttribute',
                keyPathSelected: null,
                operatorSelected: null,
                selectorAnimationDirection: null,
                value: undefined,
                selectedValueIndex: undefined,
            };
        }
        this.handleAddValue = this.handleAddValue.bind(this);
        this.handleAttributeSelection = this.handleAttributeSelection.bind(this);
        this.handleOperatorSelection = this.handleOperatorSelection.bind(this);
        this.getCustomBackButton = this.getCustomBackButton.bind(this);
        this.getAddValueMethod = this.getAddValueMethod.bind(this);
        this.getInputMethod = this.getInputMethod.bind(this);
        this.handleUpdatePageValueIndex = this.handleUpdatePageValueIndex.bind(this);
        this.handleDateOverviewSelection = this.handleDateOverviewSelection.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
    }
    getCustomBackButton(page) {
        const { device } = this.props;
        return (React.createElement("div", { style: {
                display: 'flex',
                marginLeft: device === 'Mobile' ? 16 : 8,
            }, onClick: () => {
                this.setState({
                    selectorAnimationDirection: 'rtl',
                }, () => setTimeout(() => this.setState({
                    selectorAnimationDirection: null,
                    page,
                }), 148));
            } },
            React.createElement(index_1.ChevronLeftIcon, { fill: "#000" }),
            React.createElement(index_1.Button, { text: "Back", type: "disabled", style: {
                    innerStyle: {
                        fontSize: 17,
                        padding: 0,
                        color: index_1.steel,
                        pointerEvents: 'none',
                    },
                    outerStyle: {
                        height: 24,
                        display: 'flex',
                        alignItems: 'center',
                        background: 'none',
                        pointerEvents: 'none',
                    },
                } })));
    }
    renderNavBar() {
        const { attributeType, device, onCancel } = this.props;
        const { keyPathSelected, operatorSelected, page, selectorAnimationDirection, value } = this.state;
        let navBarProps;
        const getButtonRight = () => {
            if (value == null) {
                return '';
            }
            if (Array.isArray(value) && value.filter(v => v == null).length !== 0) {
                return '';
            }
            if (operatorSelected.valueOperator === 'rangeValue' &&
                (value.filter(v => v != null).length !== 2 ||
                    value[0] >= value[1])) {
                return '';
            }
            if (operatorSelected.valueOperator === 'rangeDateValue' &&
                value[0] >= value[1]) {
                return '';
            }
            return 'Add';
        };
        switch (page) {
            case 'newCondition':
                navBarProps = {
                    buttonLeft: 'Cancel',
                    buttonLeftCallback: onCancel,
                    title: 'New Condition',
                    buttonRight: getButtonRight(),
                    buttonRightCallback: () => this.getAddValueMethod(),
                };
                break;
            case 'selectAttribute':
                if (!!keyPathSelected && selectorAnimationDirection !== 'rtl') {
                    navBarProps = {
                        customLeftElem: this.getCustomBackButton('newCondition'),
                        title: `${attributeType} Attribute`,
                    };
                }
                else {
                    navBarProps = {
                        buttonLeft: 'Cancel',
                        buttonLeftCallback: onCancel,
                        title: `${attributeType} Attribute`,
                    };
                }
                break;
            case 'selectOperator':
                navBarProps = {
                    customLeftElem: this.getCustomBackButton('newCondition'),
                };
                break;
            case 'dateOverview':
                navBarProps = {
                    customLeftElem: this.getCustomBackButton('newCondition'),
                    title: operatorSelected.valueOperator === 'rangeDateValue'
                        ? this.state.selectedValueIndex === 0
                            ? 'Start Date'
                            : 'End Date'
                        : null,
                };
                break;
            case 'selectDatePicker':
            case 'selectTimePicker':
                navBarProps = {
                    customLeftElem: this.getCustomBackButton('dateOverview'),
                };
                break;
            case 'selectTimeZone':
                navBarProps = {
                    customLeftElem: this.getCustomBackButton('newCondition'),
                    title: 'Time Zone',
                };
                break;
        }
        return (React.createElement(index_1.NavBar, Object.assign({ style: {
                buttonLeftStyle: {
                    outerStyle: {
                        marginLeft: device === 'Mobile' ? 24 : 16,
                    },
                },
                buttonRightStyle: {
                    outerStyle: {
                        marginRight: device === 'Mobile' ? 24 : 16,
                    },
                },
            } }, navBarProps)));
    }
    renderAttributeText() {
        const { attributeType, device, schemas, listEnabledKeyPaths } = this.props;
        const { keyPathSelected, operatorSelected } = this.state;
        if (keyPathSelected === null) {
            return (React.createElement(index_1.Text, { text: `${attributeType} Attribute`, size: device === 'Mobile' ? 'large' : 'medium', textStyle: {
                    color: index_1.steel,
                } }));
        }
        const removeKeyPathPrefix = (k) => k.replace(new RegExp('^attributes.'), '');
        const type = utils_1.getKeyPathAttributeType(keyPathSelected, schemas);
        const { modifier, valueOperator } = operatorSelected;
        if (type.includes('ARRAY_OF')) {
            return (React.createElement("div", { style: { display: 'flex' } },
                React.createElement("div", { onClick: e => {
                        e.stopPropagation();
                        let tempMod;
                        if (modifier === 'ANY') {
                            tempMod = 'ALL';
                        }
                        else if (modifier === 'ALL') {
                            tempMod = valueOperator !== 'booleanValue' ? 'DIRECT' : 'ANY';
                        }
                        else if (modifier === 'DIRECT') {
                            tempMod = 'ANY';
                        }
                        const initialOperatorComponent = utils_1.getInitialOperatorComponent(type.includes('DATE_TIME') && ['ALL', 'ANY'].includes(tempMod)
                            ? 'GREATER_THAN'
                            : 'EQUAL_TO', keyPathSelected, schemas, listEnabledKeyPaths, tempMod);
                        this.setState({
                            operatorSelected: initialOperatorComponent,
                            value: utils_1.getInitialValue(initialOperatorComponent.valueOperator),
                        });
                    } },
                    React.createElement(index_1.Button, { text: modifier, size: "small", type: "primary", overrideWidth: 40, style: {
                            outerStyle: {
                                height: 24,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: 10,
                                pointerEvents: 'none',
                            },
                            innerStyle: {
                                fontSize: modifier === 'DIRECT' ? 10 : 13,
                                pointerEvents: 'none',
                            },
                        }, preventDefault: false })),
                React.createElement(index_1.Text, { text: removeKeyPathPrefix(keyPathSelected), size: device === 'Mobile' ? 'large' : 'medium', textStyle: {
                        color: index_1.charcoal,
                    } })));
        }
        return (React.createElement(index_1.Text, { text: removeKeyPathPrefix(keyPathSelected), size: device === 'Mobile' ? 'large' : 'medium', textStyle: {
                color: index_1.charcoal,
            } }));
    }
    renderBase() {
        const { keyPathSelected, operatorSelected, value } = this.state;
        const { device } = this.props;
        const renderRow = (onClick, children) => {
            return (React.createElement("div", { style: {
                    alignItems: 'center',
                    display: 'flex',
                    height: device === 'Mobile' ? 72 : 56,
                    justifyContent: 'space-between',
                    borderBottom: `1px solid ${index_1.titanium}`,
                    boxSizing: 'border-box',
                }, onClick: onClick }, children));
        };
        return (React.createElement("div", { style: {
                height: '100%',
                paddingBottom: device === 'Mobile' ? 56 : 0,
                padding: device !== 'Mobile' ? '0 16px' : '0 24px',
            } },
            renderRow(() => {
                this.setState({
                    page: 'selectAttribute',
                    selectorAnimationDirection: 'ltr',
                }, () => setTimeout(() => this.setState({
                    selectorAnimationDirection: null,
                }), 148));
            }, React.createElement(React.Fragment, null,
                this.renderAttributeText(),
                React.createElement(index_1.ChevronRightIcon, { fill: index_1.silver }))),
            keyPathSelected !== null &&
                renderRow(() => {
                    this.setState({
                        page: 'selectOperator',
                        selectorAnimationDirection: 'ltr',
                    }, () => setTimeout(() => this.setState({
                        selectorAnimationDirection: null,
                    }), 148));
                }, React.createElement(React.Fragment, null,
                    React.createElement(index_1.Text, { text: ['booleanValue'].includes(operatorSelected.valueOperator)
                            ? `is ${value}`
                            : utils_1.getComparisonOperatorDisplayValue(operatorSelected.comparisonOperator), size: device === 'Mobile' ? 'large' : 'medium' }),
                    React.createElement(index_1.ChevronRightIcon, { fill: index_1.silver }))),
            operatorSelected && this.renderValueInput()));
    }
    getInputMethod(val) {
        const { schemas } = this.props;
        const { operatorSelected, keyPathSelected, page } = this.state;
        const { valueOperator, comparisonOperator } = operatorSelected;
        if (val === undefined) {
            this.setState({
                value: undefined,
            });
        }
        else {
            switch (valueOperator) {
                case 'stringValue':
                    switch (comparisonOperator) {
                        case 'IN_LIST':
                            return this.setState({
                                value: val,
                            });
                        default:
                            return this.setState({
                                value: val.trim(),
                            });
                    }
                case 'numberValue':
                    this.setState({
                        value: isNaN(val) ? undefined : parseFloat(val),
                    });
                    return;
                case 'orderedListValue':
                case 'unOrderedListValue':
                case 'rangeValue':
                    if (utils_1.attributeTypeToComparisonPredicateValue(keyPathSelected, schemas).includes('number')) {
                        this.setState({
                            value: utils_1.stringToFloatArr(val),
                        });
                    }
                    else {
                        this.setState({
                            value: val,
                        });
                    }
                    return;
                case 'booleanValue':
                    this.setState({
                        selectorAnimationDirection: 'rtl',
                        value: val,
                    }, () => setTimeout(() => this.setState({
                        selectorAnimationDirection: null,
                        page: 'newCondition',
                    }), 148));
                    return;
                case 'numberValues':
                    this.setState({
                        value: val,
                    });
                    return;
                case 'dateTimeValue':
                case 'rangeDateValue':
                case 'unOrderedDateListValue':
                case 'orderedDateListValue':
                    if (page === 'newCondition') {
                        this.setState({
                            value: val,
                        });
                    }
                    if (page === 'selectDatePicker') {
                        this.setState({
                            value: val,
                            selectorAnimationDirection: 'rtl',
                        }, () => setTimeout(() => this.setState({
                            selectorAnimationDirection: null,
                            page: 'dateOverview',
                        }), 148));
                    }
                    if (page === 'selectTimePicker') {
                        this.setState({
                            value: val,
                        });
                    }
                    if (page === 'selectTimeZone') {
                        this.setState({
                            value: val,
                            selectorAnimationDirection: 'rtl',
                        }, () => setTimeout(() => this.setState({
                            selectorAnimationDirection: null,
                            page: 'newCondition',
                        }), 148));
                    }
                    return;
                default:
                    return;
            }
        }
    }
    handleAddValue(comparisonPredicateValue) {
        const { onAdd } = this.props;
        const { keyPathSelected, operatorSelected } = this.state;
        onAdd({
            keyPath: keyPathSelected,
            value: comparisonPredicateValue,
            modifier: operatorSelected.modifier,
            operator: operatorSelected.comparisonOperator,
        });
    }
    getAddValueMethod() {
        const { operatorSelected, value } = this.state;
        const { valueOperator, comparisonOperator } = operatorSelected;
        switch (valueOperator) {
            case 'stringValue':
                switch (comparisonOperator) {
                    case 'IN_LIST':
                        return this.handleAddValue(utils_1.sanitizeValue({ listValue: value }));
                    default:
                        return this.handleAddValue(utils_1.sanitizeValue({ stringValue: value }));
                }
            case 'numberValue':
                return this.handleAddValue(utils_1.sanitizeValue({ numberValue: value }));
            case 'orderedListValue':
            case 'unOrderedListValue':
            case 'rangeValue':
                return this.handleAddValue(utils_1.sanitizeValue({
                    [utils_1.getOperatorByValueType(value)]: value,
                }));
            case 'booleanValue':
                return this.handleAddValue(utils_1.sanitizeValue({ booleanValue: value }));
            case 'numberValues':
                return this.handleAddValue(utils_1.sanitizeValue({ numberValues: value }));
            case 'dateTimeValue':
                return this.handleAddValue(utils_1.sanitizeValue({ dateTimeValue: value }));
            case 'orderedDateListValue':
            case 'unOrderedDateListValue':
            case 'rangeDateValue':
                return this.handleAddValue(utils_1.sanitizeValue({ dateTimeValues: value }));
            default:
                return;
        }
    }
    renderValueInput() {
        const { device, popOverTargetParent, lists, onListUpload } = this.props;
        const { operatorSelected, value } = this.state;
        const { valueOperator, comparisonOperator } = operatorSelected;
        switch (valueOperator) {
            case 'stringValue':
                switch (comparisonOperator) {
                    case 'IN_LIST':
                        return (React.createElement(PredicateListInput_1.default, { uploadList: onListUpload, device: device, popOverTargetParent: popOverTargetParent, value: value, lists: lists, onSelected: this.getInputMethod }));
                    default:
                        return (React.createElement(PredicateInputValue_1.default, { device: device, handleAddValue: this.getAddValueMethod, handleInputChange: this.getInputMethod, value: value }));
                }
            case 'numberValue':
                return (React.createElement(PredicateInputValue_1.default, { device: device, handleAddValue: this.getAddValueMethod, handleInputChange: this.getInputMethod, value: value && value.toString(), numberInput: true }));
            case 'orderedListValue':
            case 'unOrderedListValue':
                return (React.createElement(PredicateListValue_1.default, { device: device, ordered: valueOperator === 'orderedListValue', values: value, handleValueUpdate: this.getInputMethod }));
            case 'rangeValue':
                return (React.createElement(PredicateRangeValue_1.default, { device: device, values: value, handleValueUpdate: this.getInputMethod }));
            case 'numberValues':
                return (React.createElement(GeofenceInput_1.default, { device: device, latitude: value && value[0], longitude: value && value[1], radius: value && value[2], handleUpdate: this.getInputMethod }));
            case 'dateTimeValue':
                return (React.createElement(PredicateDateTimePageSelector_1.default, { device: device, value: value, updatePageSelected: this.handlePageSelect }));
            case 'rangeDateValue':
                return (React.createElement(PredicateRangeDatePageValueIndexSelector_1.default, { device: device, values: value, updatePageValueIndexSelected: this.handleUpdatePageValueIndex }));
            case 'orderedDateListValue':
            case 'unOrderedDateListValue':
                return (React.createElement(PredicateListDatePageValueIndexSelector_1.default, { device: device, values: value, updatePageValueIndexSelected: this.handleUpdatePageValueIndex, handleValueUpdate: this.getInputMethod, ordered: valueOperator === 'orderedDateListValue' }));
            default:
                return React.createElement("div", null);
        }
    }
    handlePageSelect(page) {
        this.setState({
            selectorAnimationDirection: 'ltr',
            page,
        }, () => setTimeout(() => this.setState({
            selectorAnimationDirection: null,
        }), 148));
    }
    handleUpdatePageValueIndex(page, selectedValueIndex) {
        this.setState({
            selectorAnimationDirection: 'ltr',
            page,
            selectedValueIndex,
        }, () => setTimeout(() => this.setState({
            selectorAnimationDirection: null,
        }), 148));
    }
    handleAttributeSelection(keyPathSelected) {
        const { schemas, listEnabledKeyPaths } = this.props;
        const attributeType = utils_1.getKeyPathAttributeType(keyPathSelected, schemas);
        const initialOperatorComponent = utils_1.getInitialOperatorComponent(attributeType.includes('DATE_TIME') ? 'GREATER_THAN' : 'EQUAL_TO', keyPathSelected, schemas, listEnabledKeyPaths);
        this.setState({
            selectorAnimationDirection: 'rtl',
            keyPathSelected,
            operatorSelected: initialOperatorComponent,
            value: utils_1.getInitialValue(initialOperatorComponent.valueOperator),
        }, () => setTimeout(() => this.setState({
            selectorAnimationDirection: null,
            page: 'newCondition',
        }), 148));
    }
    handleOperatorSelection(operatorSelected, resetValue) {
        const getValue = () => {
            const { valueOperator } = this.state.operatorSelected;
            if ((operatorSelected.valueOperator === 'rangeDateValue' && valueOperator !== 'rangeDateValue') ||
                (['unOrderedDateListValue', 'orderedDateListValue'].includes(operatorSelected.valueOperator) &&
                    !['unOrderedDateListValue', 'orderedDateListValue'].includes(valueOperator))) {
                return [
                    luxon_1.DateTime.local().set({ second: 0, millisecond: 0 }).toISO(),
                    luxon_1.DateTime.local().plus({ hours: 1 }).set({ second: 0, millisecond: 0 }).toISO(),
                ];
            }
            if (operatorSelected.valueOperator === 'dateTimeValue' && valueOperator !== 'dateTimeValue') {
                return luxon_1.DateTime.local().set({ second: 0, millisecond: 0 }).toISO();
            }
            if (resetValue) {
                return undefined;
            }
            return this.state.value;
        };
        this.setState({
            selectorAnimationDirection: 'rtl',
            operatorSelected,
            value: getValue(),
        }, () => setTimeout(() => this.setState({
            selectorAnimationDirection: null,
            page: 'newCondition',
        }), 148));
    }
    handleDateOverviewSelection(page) {
        this.setState({ page, selectorAnimationDirection: 'ltr' }, () => setTimeout(() => this.setState({
            selectorAnimationDirection: null,
        }), 148));
    }
    render() {
        const { device, schemas, listEnabledKeyPaths } = this.props;
        const { page, keyPathSelected, selectorAnimationDirection, operatorSelected, value, selectedValueIndex } = this.state;
        return (React.createElement("div", { style: {
                width: device === 'Mobile' ? '100%' : 384,
                height: device === 'Mobile' ? '100%' : 434,
                background: index_1.white,
                position: 'relative',
                overflow: 'hidden',
            } },
            this.renderNavBar(),
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: device === 'Mobile' ? 'calc(100% - 56px)' : 378,
                    overflow: 'scroll',
                }, id: "predicate-builder-body" }, this.renderBase()),
            page === 'selectAttribute' && (React.createElement(AttributeSelector_1.default, { device: device, selected: keyPathSelected, keyPaths: schemas, onSelect: this.handleAttributeSelection, selectorAnimationDirection: selectorAnimationDirection })),
            (page === 'dateOverview' || page === 'selectDatePicker' || page === 'selectTimePicker') && (React.createElement(DateOverviewSelector_1.default, { device: device, value: value, selectorAnimationDirection: selectorAnimationDirection, selectedValueIndex: selectedValueIndex, page: page, onSelect: this.handleDateOverviewSelection })),
            page === 'selectOperator' &&
                (!['booleanValue'].includes(operatorSelected.valueOperator) ? (React.createElement(OperatorSelector_1.default, { device: device, selected: operatorSelected, operators: utils_1.getOperators(keyPathSelected, schemas, listEnabledKeyPaths, operatorSelected ? operatorSelected.modifier : null), onSelect: this.handleOperatorSelection, selectorAnimationDirection: selectorAnimationDirection })) : (React.createElement(BooleanOperatorValueSelector_1.default, { device: device, value: value, onSelect: this.getInputMethod, selectorAnimationDirection: selectorAnimationDirection }))),
            page === 'selectDatePicker' && (React.createElement(DatePickerSelector_1.default, { device: device, onSelect: this.getInputMethod, selectorAnimationDirection: selectorAnimationDirection, selectedValueIndex: selectedValueIndex, value: value })),
            page === 'selectTimePicker' && (React.createElement(TimePickerSelector_1.default, { device: device, onSelect: this.getInputMethod, selectorAnimationDirection: selectorAnimationDirection, selectedValueIndex: selectedValueIndex, value: value })),
            page === 'selectTimeZone' && (React.createElement(TimeZoneSelector_1.default, { device: device, onSelect: this.getInputMethod, selectorAnimationDirection: selectorAnimationDirection, selectedValueIndex: selectedValueIndex, value: value }))));
    }
}
exports.default = PredicateBuilder;
